import {getGlobalObject} from '../utils/getGlobal'
const globalObject = getGlobalObject()

const ErrorType = 'promise reject'

export const debugPromise = () => {
    // const originPromiseReject = globalObject.Promise.reject
    // globalObject.Promise.reject = function(reason) {
    //     return originPromiseReject.apply(this, reason)
    // }

    window.addEventListener('rejectionhandled', err => {
        err.preventDefault()
        console.log('rejectionhandled', err)
        return true
    })
    window.addEventListener('unhandledrejection', err => {
        err.preventDefault()
        console.log('unhandledrejection', err)
        return true
    })
}
